import React from 'react';
import css from './LandingPageLoggedOutMenu.css';
import { useHistory } from 'react-router-dom';
import { InlineTextButton } from '../../../../components';
import { IconChevronBottomStrongM } from '../../../../icons';
import { dropdownsConfig, FIND_HORSE, FIND_SUPPORT, RESOURCES, ABOUT_US } from './dropdowns';
import DropdownHolder from './DropdownHolder';
import classNames from 'classnames';

export default () => {
    const history = useHistory();

    return [FIND_HORSE, FIND_SUPPORT, RESOURCES, ABOUT_US].map((id, index) => (
        <InlineTextButton
            key={index}
            className={classNames(css.root, {
                [css.selected]: dropdownsConfig[id].isSelected(history),
            })}
        >
            <span>{dropdownsConfig[id].label}</span>
            <code className={css.bottomLine} />
            <IconChevronBottomStrongM />
            <DropdownHolder dropdownId={id} rootClassName={css.dropdownItems}>
                {dropdownsConfig[id].items}
            </DropdownHolder>
        </InlineTextButton>
    ));
};
